import { useAtomValue } from 'jotai';
import { type ReactElement } from 'react';

import { archetypeScoresAtom } from '../state/draftAtoms';

const COLOR_PAIR_NAMES: Record<string, string> = {
  WU: 'Azorius',
  WB: 'Orzhov',
  WR: 'Boros',
  WG: 'Selesnya',
  UB: 'Dimir',
  UR: 'Izzet',
  UG: 'Simic',
  BR: 'Rakdos',
  BG: 'Golgari',
  RG: 'Gruul',
};

export default function ArchetypeIndicator(): ReactElement {
  const scores = useAtomValue(archetypeScoresAtom);

  if (scores.length === 0) {
    return (
      <div className="space-y-2">
        <h3 className="text-xs font-semibold tracking-wider text-zinc-400 uppercase">Archetype</h3>
        <p className="text-xs text-zinc-500">Draft more cards to see archetypes</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <h3 className="text-xs font-semibold tracking-wider text-zinc-400 uppercase">Archetype</h3>
      <div className="space-y-1.5">
        {scores.slice(0, 2).map(({ archetype, score }) => {
          const pairName = COLOR_PAIR_NAMES[archetype.name] ?? archetype.name;
          const percentage = Math.round(score * 100);
          return (
            <div key={archetype.name} className="flex items-center gap-2">
              <span className="text-xs font-medium text-zinc-200">{archetype.colors.join('')}</span>
              <span className="flex-1 truncate text-xs text-zinc-400">{pairName}</span>
              <span className="text-xs font-medium text-zinc-300">{percentage}%</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
